// Visualizzazione (sola lettura) di orario DICHIARATO vs TIMBRATURA EFFETTIVA.
// Riusa i timestamp reali salvati dal backend (server_open_at / server_close_at, UTC)
// convertiti in Europe/Rome. Nessuna modifica alle regole di timbratura/anomalie.
import { GeoAnomalyNote } from "@/components/GeoAnomalyNote";

const NA = "Dato non disponibile";

export function stampTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleTimeString("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
}

// Data reale della timbratura (Europe/Rome): ISO (yyyy-mm-dd) per il confronto, IT (dd/mm/aaaa) per la vista.
function stampDateIso(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-CA", { timeZone: "Europe/Rome" });
}
function stampDateIt(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  return d.toLocaleDateString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric" });
}

function Row({ label, value, testid, strong }) {
  return (
    <div className="flex justify-between gap-3">
      <span className="text-slate-500">{label}</span>
      <span className={`tabular-nums ${value ? "text-slate-800" : "text-slate-400 italic"} ${strong ? "font-bold" : "font-medium"}`} data-testid={testid}>
        {value || NA}
      </span>
    </div>
  );
}

export function StampInfo({ entry, className = "" }) {
  const isOpen = entry.status === "in_corso";
  const inReal = stampTime(entry.server_open_at);
  const outReal = stampTime(entry.server_close_at);

  // Errore di timbratura conteggiabile SOLO se l'Ufficio ha valutato l'anomalia come
  // NON giustificata (validated === false). Pending (null) e giustificate (true) → nessun grassetto.
  const inErr = !!entry.open_anomaly && entry.open_anomaly_validated === false;
  const outErr = !!entry.close_anomaly && entry.close_anomaly_validated === false;

  // Se la timbratura reale (errata) cade in una data diversa da quella di riferimento della
  // prestazione, mostra ora · data (tutto in grassetto). Se coincide, solo l'ora.
  const startRef = entry.work_date;
  const endRef = entry.end_date || entry.work_date;
  const inRealDate = stampDateIso(entry.server_open_at);
  const outRealDate = stampDateIso(entry.server_close_at);
  const inValue = inReal
    ? (inErr && inRealDate && inRealDate !== startRef ? `${inReal} · ${stampDateIt(entry.server_open_at)}` : inReal)
    : null;
  const outValue = outReal
    ? (outErr && outRealDate && outRealDate !== endRef ? `${outReal} · ${stampDateIt(entry.server_close_at)}` : outReal)
    : null;

  return (
    <div className={`text-xs space-y-0.5 rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-2 ${className}`} data-testid={`stamp-info-${entry.id}`}>
      <Row label="Entrata dichiarata" value={entry.start_time} testid={`stamp-in-decl-${entry.id}`} />
      <Row label={isOpen ? "Timbratura effettuata alle" : "Entrata timbrata alle"} value={inValue} strong={inErr} testid={`stamp-in-real-${entry.id}`} />
      {!isOpen && (
        <>
          <Row label="Uscita dichiarata" value={entry.end_time} testid={`stamp-out-decl-${entry.id}`} />
          <Row label="Uscita timbrata alle" value={outValue} strong={outErr} testid={`stamp-out-real-${entry.id}`} />
        </>
      )}
      {entry.open_geo?.out_of_area && <GeoAnomalyNote phase="open" geo={entry.open_geo} testid={`stamp-geo-open-${entry.id}`} className="pt-1" />}
      {entry.close_geo?.out_of_area && <GeoAnomalyNote phase="close" geo={entry.close_geo} testid={`stamp-geo-close-${entry.id}`} className="pt-1" />}
    </div>
  );
}
